<template>
  <div class="product_total container">
    <h3 class="stitle mb50">전체상품</h3>
    <div id="tabMenu" class="mb50">
      <ul class="tab_div2">
        <li :class="{ active: currTab === 'sale' }"><a href="#">판매중상품</a></li>
        <li :class="{ active: currTab === 'end' }"><a href="#end">종료상품</a></li>
      </ul>
    </div>
    <div class="mb20" v-if="streetList.length > 0">
      <a @click="() => changeFilter('')" class="click-chip-hover outline" :class="{ active: !filter }">#전체</a>
      <a
        v-for="street in streetList"
        :key="street.exhpHzCd"
        @click="() => changeFilter(street.exhpHzCd)"
        class="click-chip-hover outline"
        :class="{ active: street.exhpHzCd === filter }"
      >
        #{{ street.exhpHallNm }}
      </a>
    </div>
    <div class="mb20" v-if="subFilterList.length > 0">
      <a
        v-for="exhp in subFilterList"
        :key="exhp.exhpHzCd"
        @click="() => changeSubFilter(exhp.exhpHzCd)"
        class="click-chip-hover outline"
        :class="{ active: exhp.exhpHzCd === subFilter }"
      >
        #{{ exhp.exhpHallNm }}
      </a>
    </div>
    <ul class="pdlist" v-if="loading" key="skeleton">
      <li v-for="i in 4" :key="i">
        <a>
          <span>
            <SkeletonBox width="100%" height="0" paddingTop="85.7%" />
          </span>
          <dl>
            <dt>
              <SkeletonBox :minWidth="30" :maxWidth="80" />
            </dt>
            <dd></dd>
            <dd class="explan">
              <SkeletonBox :minWidth="80" :maxWidth="100" />
              <SkeletonBox :minWidth="80" :maxWidth="100" />
              <SkeletonBox :minWidth="30" :maxWidth="70" />
            </dd>
            <dd class="amount">
              <SkeletonBox :minWidth="20" :maxWidth="30" />
            </dd>
          </dl>
        </a>
      </li>
    </ul>
    <ul class="pdlist" v-else key="data-list">
      <!-- v-for를 template에서 사용하고, v-else를 제거해도 됨-->
      <li v-for="productItem in showItems" :key="productItem.mrktnPdNo">
        <router-link
          :to="{
            path: `/${currentRouteType}/${$route.params.expDiv}/${productItem.mrktnPdNo}`,
          }"
        >
          <!-- <span>
            <SkeletonBox width="100%" height="0" paddingTop="85.7%" :image="productItem.filePath" :alt="productItem.pdNm" />
          </span> -->
          <span>
            <div class="thumbnail">
              <div class="thumbnail-centered">
                <img :src="productItem.filePath" :alt="productItem.pdNm" @error="$changeDefaultImage" class="thumbnail-img" />
              </div>
            </div>
          </span>
          <dl>
            <dt>{{ productItem.mrktnPdNm }}</dt>
            <dd class="explan" v-html="productItem.salepdExpl"></dd>
          </dl>
        </router-link>
      </li>
    </ul>
    <div v-if="!loading && showItems.length === 0">
      <div style="display: flex; justify-content: center; align-items: center;">대상 상품이 없습니다.</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { getMakiveStreet } from '@/api/api_product';

export default {
  components: {},
  data() {
    return {
      streetList: [],
      exphList: [],
      filter: '',
      subFilter: '',
    };
  },
  computed: {
    ...mapState({ loading: (state) => state.product.loadingItems }),
    ...mapGetters(['productItems', 'endProductItems']),
    currTab() {
      return this.$route.hash === '#end' ? 'end' : 'sale';
    },
    tabItems() {
      return this.currTab === 'end' ? this.endProductItems : this.productItems;
    },
    showItems() {
      if (this.filter) {
        if (this.subFilter && this.subFilter !== this.filter) {
          return this.tabItems.filter((item) => item.exhpHzCd?.includes(this.subFilter));
        } else {
          return this.tabItems.filter((item) => item.exhpHzCd?.includes(this.filter));
        }
      } else {
        return this.tabItems;
      }
    },
    subFilterList() {
      return this.exphList.filter((item) => item.upperCd === this.filter);
    },
  },
  watch: {
    currTab(to) {
      if (this.tabItems.length < 1) {
        to === 'end' ? this.getEndProductItems(this.pgDiv) : this.getProductItems(this.pgDiv);
      }
    },
  },
  methods: {
    ...mapActions(['getProductItems', 'getEndProductItems']),
    changeFilter(value) {
      this.filter = value;

      //y.class 서브메뉴 분기
      if (value === '6300005') {
        this.subFilter = '6300005';
      } else {
        this.subFilter = '';
      }
    },
    changeSubFilter(value) {
      this.subFilter = value;
    },
  },
  created() {
    if (this.$route.params?.expDiv === 'makive') {
      getMakiveStreet().then((res) => {
        this.streetList = res.data.response.makiveStreet;
        this.exphList = res.data.response.makiveExph;
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.click-chip,
.click-chip-hover {
  padding: 4px 12px;
  border-radius: 50px;
  display: inline-flex;
  margin: 5px;
  cursor: pointer;
  line-height: 18px;
}

.click-chip-hover:hover {
  filter: brightness(85%);
}
.outline.active {
  border-color: #eaeaea;
  background: #eaeaea;
}

.outline {
  border: 1.5px solid #ccc;
  color: #333;
  outline: none;
}
.thumbnail {
  position: relative;
  padding-top: 85%;
  overflow: hidden;
}

.thumbnail-centered {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transform: translate(50%, 50%);
}

.thumbnail-img {
  /*   max-width: 100%; */
  /*   height: 박스의 height와 같아야 한다. */
  transform: translate(-50%, -50%);
}

#productList .product_recom li span {
  & img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
}

@media (max-width: 540px) {
  #productList .product_total .pdlist li dt {
    font-size: 17px;
    word-break: keep-all;
  }
  #productList .product_total .pdlist li .explan {
    font-size: 14px;
  }
}
</style>
